import React, { Component } from "react";
import CalendarPicker from './popup/Calendar'
// import * as R from 'ramda'
import M from 'moment'

class SimpleDateRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.date ? M(props.date, 'DD-MM-YYYY').toDate() : '',
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.date !== prevProps.date) {
            this.setState({
                date: this.props.date ? M(this.props.date, 'DD-MM-YYYY').toDate() : '',
            })
        }
    }

    render() {
        const { label, subLabel, mandatory, monthYear } = this.props
        const { date } = this.state
        return (
            <div className="grid grid-4x grid-mobile-none gap-15px padding-top-15px margin-bottom-20px"
            style={{flexDirection:"row", justifyContent:"space-between", alignContent:"center"}}>
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{ color: 'red' }}>*</span>}</h4>
                    </div>
                    <div className="txt-site txt-11 txt-primary margin-5px">
                        {subLabel}
                    </div>
                </div>
                {monthYear ?
                    <input {...this.props} className="txt txt-sekunder-color" type="month"></input> :
                    <div style={{width:200, marginLeft: -50}}>
                    <CalendarPicker
                        {...this.props}
                        date={date === 'invalid date' ? '' : date}
                    />
                    </div>
                }
            </div>
        )
    }
}

export default SimpleDateRow